import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { RouteEditMode } from 'src/app/_models/state/routeState';
import { LngLatLike } from '@trimblemaps/trimblemaps-js';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { ViewRouteStop } from 'src/app/_models/view/routeStop';
import { Clipboard } from '@angular/cdk/clipboard';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AddFavoriteModalComponent } from '../../add-favorite-modal/add-favorite-modal.component';
import {
  createModalOptions,
  deleteFavoriteModalOptions,
} from 'src/app/_helpers/create-modal-options';
import { StopLocation } from 'src/app/_models/state/stopState';
import { Observable } from 'rxjs';
import {
  SingleSearchLocation,
  SingleSearchLocationAddress,
} from 'src/app/_models/pcmws/singleSearch/singleSearchResponse';
import { Coords } from 'src/app/_models/common/coords';
import { PlaceSetService } from 'src/app/services/place-set.service';
import { ModalboxComponent } from '../../modalbox/modalbox.component';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';

// TODO consider alternatives to element selctor (currently a tr)
/* eslint-disable  @angular-eslint/component-selector */
@Component({
  selector: '[app-stop-item]',
  templateUrl: './stop-item.component.html',
  styleUrls: ['./stop-item.component.scss'],
})
export class StopItemComponent implements OnInit, OnDestroy {
  @Input() stop: ViewRouteStop;
  @Input() stopIndex: number;
  @Input() showToll: boolean;
  @Input() displayCurrency: CurrencyState;
  @Input() precision: number;
  isTollsAvailable: boolean;
  loc: SingleSearchLocation;
  // Enum references for template use
  routeEditModeEnum = RouteEditMode;
  stopTimeLabel: string;
  location$: Observable<StopLocation>;
  @Output() delete = new EventEmitter<number>();
  @Output() centerStop = new EventEmitter<LngLatLike>();
  @Output() showReport = new EventEmitter<boolean>();
  private sm = new SubscriptionManager();

  constructor(
    private clipboard: Clipboard,
    private modalService: BsModalService,
    private placeSetService: PlaceSetService
  ) {}
  ngOnInit(): void {
    if (this.stop?.lngLat) {
      this.setFavouriteLocation();
    }
    this.isTollsAvailable = this.showToll && (this.stop.tolls ? true : false); // .tolls is a string.

    this.stopTimeLabel =
      this.stop?.formControl?.value || this.stop?.formControl?.value === 0
        ? this.getTimeFormat(this.stop?.formControl?.value?.toString())
        : 'Stop Duration';
    this.detectChanges();
  }
  setFavouriteLocation() {
    const coords: Coords = {
      Lat: this.stop?.lngLat[1].toString(),
      Lon: this.stop?.lngLat[0].toString(),
    };
    const address: SingleSearchLocationAddress = {
      StreetAddress: this.stop.address?.streetAddress,
      City: this.stop?.address.city,
      State: this.stop.address.state,
      StateName: null,
      Zip: this.stop.address.zip,
      County: this.stop.address.county,
      Country: this.stop.address.country,
      CountryFullName: this.stop.address.countryFullName,
      SPLC: this.stop.address.SPLC,
      StateAbbreviation: this.stop.address.state,
      CountryAbbreviation: this.stop.address.country,
    };
    const loc: SingleSearchLocation = {
      Address: address,
      Coords: coords,
    };
    this.location$ =
      this.placeSetService.checkPlaceCoordsBelongsToFavorite(loc);
  }
  detectChanges() {
    this.stop?.formControl?.valueChanges.subscribe((data) => {
      this.stopTimeLabel = this.getTimeFormat(data);
    });
  }
  deleteStop() {
    this.delete.emit(this.stopIndex);
  }

  showOnMap() {
    this.centerStop.emit(this.stop.lngLat);
  }
  openReport() {
    this.showReport.emit(true);
    return false;
  }
  saveFavorite(location: StopLocation) {
    this.modalService.show(
      AddFavoriteModalComponent,
      createModalOptions({ initialState: location })
    );
  }
  removeFavorite(location: StopLocation) {
    const options = deleteFavoriteModalOptions({
      id: location.favoriteId,
      name: location.name,
    });
    const dialogRef = this.modalService.show<ModalboxComponent>(
      ModalboxComponent,
      options
    );
    dialogRef.content.event.subscribe((id: number) => {
      this.sm.manage = this.placeSetService.deletePlace(id).subscribe();
    });
  }
  copyToClipboard() {
    const id = `copy-table_${this.stopIndex.toString()}`;
    const table = document.getElementById(id);
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(table);
    selection.removeAllRanges();
    selection.addRange(range);
    this.clipboard.copy(selection.toString());
    selection.removeAllRanges();
  }
  getTimeFormat(value: string) {
    const timeFormat: string = value
      ? value.includes(':')
        ? 'Stop Duration (hh:mm)'
        : value.includes('.')
        ? 'Stop Duration (hh.hh)'
        : 'Stop Duration (mm)'
      : 'Stop Duration';
    return timeFormat;
  }
  ngOnDestroy(): void {
    this.sm.unsubscribe();
  }
}
